<template>
  <div class="track">
    <div class="track-container">
      <div class="track-header">
        <div class="title">
          <div class="left">
            <span @click="$router.push({ name: 'RecordList' })">我可以查看的跟进记录</span>
            <van-icon name="arrow" />
          </div>
          <van-button size="mini" @click="$router.push({ name: 'CreateTrack' })">添加跟进记录</van-button>
        </div>
        <van-divider />
        <van-dropdown-menu class="search border-bottom" active-color="#1989fa">
          <van-dropdown-item title="搜索" ref="search">
            
            <van-radio-group v-model="radioNum" direction="horizontal" style="padding: 20px 0 5px 12px;font-size: 14px;">
              <van-radio :name="1">客户名称</van-radio>
              <van-radio :name="2">操作人名称</van-radio>
            </van-radio-group>

            <van-search
              v-model="query.customerName"
              show-action
              autofocus
              :placeholder="radioNum===1 ? '客户名称' : '操作人名称'"
            >
              <template #action>
                <van-button size="small" @click="searchCustomer">搜索</van-button>
              </template>
            </van-search>
          </van-dropdown-item>
          <van-dropdown-item :title="filterDate" ref="calendar">
            <van-calendar
              :show-title="false"
              :min-date="minDate"
              :default-date="[new Date(query.startTime * 1000), new Date(query.endTime * 1000)]"
              :poppable="false"
              :style="{ height: '400px' }"
              :show-confirm="true"
              color="#1989fa"
              row-height="58"
              type="range"
              @confirm="handleSelectDate"
            />
          </van-dropdown-item>
        </van-dropdown-menu>
        <van-divider />
      </div>
      <div class="list-items">
        <template v-for="item in list">
          <TrackItem :key="item.id" :data="item" />
        </template>
      </div>
    </div>
    <div class="page">
      <span class="page-count">共{{ totalCount }}条数据</span>
      <Pagination v-bind.sync="page" :totalCount="totalCount" />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import Pagination from '@/components/pagination'
import TrackItem from './components/item'
import { trackList } from '@/api/track'
import { getMonthStartTime, getMonthEndTime, currentMonth } from '@/utils'
export default {
  name: 'CustomerTrack',
  components: { Pagination, TrackItem },
  data() {
    return {
      radioNum: 1,
      filterDate: '跟进日期',
      page: {
        currentPage: 1,
        currentCount: 10
      },
      query: {
        customerName: undefined,
        startTime: getMonthStartTime(currentMonth),
        endTime: getMonthEndTime(currentMonth)
      },
      totalCount: 0,
      list: []
    }
  },
  created() {
    this.getTrackList();
  },
  watch: {
    page: {
      handler() {
        this.getTrackList()
      },
      deep: true
    }
  },
  computed: {
    minDate() {
      return dayjs(currentMonth).startOf('year').startOf('day').toDate()
    }
  },
  methods: {
    getTrackList() {
      // 获取跟进记录列表
      const { currentPage, currentCount } = this.page
      const params = {
        page: currentPage,
        count: currentCount,
        ...this.query,
        customerName: this.radioNum === 1 ? (this.query.customerName || undefined) : undefined,
        operatorName: this.radioNum === 2 ? (this.query.customerName || undefined) : undefined
      };
      trackList(params).then(res => {
        if (res.errcode === 0) {
          this.list = res.data
          this.totalCount = res.page.totalCount
        }
      })
    },
    searchCustomer() {
      this.$refs.search.toggle()
      this.getTrackList()
    },
    handleSelectDate(date) {
      this.$refs.calendar.toggle()
      const [start, end] = date
      this.filterDate = `${dayjs(start).format('YYYY-MM-DD')} ~ ${dayjs(end).format('YYYY-MM-DD')}`
      this.query = {
        ...this.query,
        startTime: dayjs(start).startOf('day').unix(),
        endTime: dayjs(end).endOf('day').unix()
      }
      this.getTrackList()
    }
  }
}
</script>

<style lang="less" scoped>
.track { height: 100vh;
  &-container { height: calc(~'100% - 45px');
    .track-header { background-color: #fff; margin-bottom: 10px;
      .title { display: flex; justify-content: space-between; align-items: center; padding: 10px 16px; font-size: 14px;
        .left { display: flex; align-items: center;
          .van-icon-arrow { vertical-align: middle; margin-left: 10px; color: #969799; }
        }
        .van-divider { margin: 0; }
        .van-button { background-color: transparent; border: none; font-size: 14px; color: #F59A23; }
      }
      .search {
        /deep/ .van-dropdown-menu__bar { background-color: transparent; box-shadow: none; height: 40px; }
        /deep/ .van-dropdown-menu__item { position: relative;
          &:not(:last-of-type)::after {
            content: '';
            position: absolute;
            width: 1px;
            height: 100%;
            right: 0;
            bottom: 0;
            border-right: 1px solid #ebedf0;
            transform: scaleX(0.5);
          }
        }
      }
    }
    .list-items {font-size: 12px; color: #333; height: calc(~'100% - 100px'); overflow: auto; }
  }
  .page { display: flex; align-items: center; justify-content: space-between; padding: 0 10px; margin-top: 5px;
    &-count { font-size: 14px; white-space: nowrap; }
    .van-pagination { padding: 0; }
  }
}
</style>
